export const getWindowHeight = (adjust = 0) => {
  return window.innerHeight - adjust + 'px'
}
